const SubjectTopicName = [

  {
    "_id": {
      "$oid": "mathmocktest10"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "1-সংখ্যা তত্ত্ব (Number System) ➔",
    "topicssymbol": "CM01",
  },
  {
    "_id": {
      "$oid": "mathmocktest02"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "2-শতাংশ (Percentages) ➔",
    "topicssymbol": "CM02",
  },
  {
    "_id": {
      "$oid": "mathmocktest03"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "3-লাভ, ক্ষতি এবং ছাড় (Profit, Loss, and Discount) ➔",
    "topicssymbol": "CM03",
  },
  {
    "_id": {
      "$oid": "mathmocktest04"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "4-অনুপাত ও সমানুপাত (Ratio and Proportion) ➔",
    "topicssymbol": "CM04",
  },
  {
    "_id": {
      "$oid": "mathmocktest05"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "5-গড় (Averages) ➔",
    "topicssymbol": "CM05",
  },
  {
    "_id": {
      "$oid": "mathmocktest06"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "6-সময় ও কার্য (Time and Work) ➔",
    "topicssymbol": "CM06",
  },
  {
    "_id": {
      "$oid": "mathmocktest07,"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "7-সময়, গতিবেগ ও দূরত্ব (Time, Speed, and Distance) ➔",
    "topicssymbol": "CM07",
  },
  {
    "_id": {
      "$oid": "mathmocktest08"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "8-সরল ও চক্রবৃদ্ধি সুদ (Simple & Compound Interest) ➔",
    "topicssymbol": "CM08",
  },
  {
    "_id": {
      "$oid": "mathmocktest09"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "9-মিশ্রণ (Mixtures and Alligations) ➔",
    "topicssymbol": "CM09",
  },
  {
    "_id": {
      "$oid": "mathmocktest10"
    },
    "topicstype": "mocktest",
    "topicssubject": "math",
    "topicsname": "10-সরল ও দ্বিঘাত সমীকরণ (Linear & Quadratic Equations) ➔",
    "topicssymbol": "CM10",
  },



  {
    "_id": {
      "$oid": "reasoningmocktest01"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "1-কোডিং-ডিকোডিং (Coding-Decoding) ➔",
    "topicssymbol": "CR01",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest02"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "2-রক্তের সম্পর্ক (Blood Relations) ➔",
    "topicssymbol": "CR02",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest03"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "3-দিকনির্ণয় পরীক্ষা (Direction Sense Test) ➔",
    "topicssymbol": "CR03",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest04"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "4-সিলোজিসম যুক্তিবিচার (Syllogism) ➔",
    "topicssymbol": "CR04",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest05"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "5-শ্রেণী বিন্যাস (Series Completion) ➔",
    "topicssymbol": "CR05",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest06"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "6-সাদৃশ্য ও শ্রেণীবিভাগ (Analogy & Classification) ➔",
    "topicssymbol": "CR06",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest07"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "7-ক্রম ও র‍্যাঙ্কিং (Order and Ranking) ➔",
    "topicssymbol": "CR07",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest08"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "8-দর্পণ ও জল প্রতিচ্ছবি (Mirror and Water Images) ➔",
    "topicssymbol": "CR08",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest09"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "9-লুকানো চিত্র (Hidden Figures) ➔",
    "topicssymbol": "CR09",
  },
  {
    "_id": {
      "$oid": "reasoningmocktest10"
    },
    "topicstype": "mocktest",
    "topicssubject": "reasoning",
    "topicsname": "10-কাগজ ভাঁজ ও কাটা (Paper Folding and Cutting) ➔",
    "topicssymbol": "CR10",
  },



  {
    "_id": {
      "$oid": "englishmocktest01"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "1-সমার্থক ও বিপরীতার্থক শব্দ (Synonyms and Antonyms) ➔",
    "topicssymbol": "CE01",
  },
  {
    "_id": {
      "$oid": "englishmocktest02"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "2-বাগধারা ও শব্দগুচ্ছ (Idioms and Phrases) ➔",
    "topicssymbol": "CE02",
  },
{
    "_id": {
      "$oid": "englishmocktest03"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "3-এক কথায় প্রকাশ (One-Word Substitution) ➔",
    "topicssymbol": "CE03",
  },
{
    "_id": {
      "$oid": "englishmocktest04"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "4-প্রাসঙ্গিক ব্যবহার (Contextual Usage) ➔",
    "topicssymbol": "CE04",
  },
{
    "_id": {
      "$oid": "englishmocktest05"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "5-বানান পরীক্ষা (Spelling Tests) ➔",
    "topicssymbol": "CE05",
  },
{
    "_id": {
      "$oid": "englishmocktest06"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "6-ভুল সংশোধন (Error Spotting) ➔",
    "topicssymbol": "CE06",
  },
{
    "_id": {
      "$oid": "englishmocktest07"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "7-বাক্য সংশোধন (Sentence Improvement) ➔",
    "topicssymbol": "CE07",
  },
{
    "_id": {
      "$oid": "englishmocktest08"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "8-পদ প্রকরণ (Parts of Speech) ➔",
    "topicssymbol": "CE08",
  },
{
    "_id": {
      "$oid": "englishmocktest09"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "9-বাচ্য পরিবর্তন (Active and Passive Voice) ➔",
    "topicssymbol": "CE09",
  },
{
    "_id": {
      "$oid": "englishmocktest10"
    },
    "topicstype": "mocktest",
    "topicssubject": "english",
    "topicsname": "10-উক্তি পরিবর্তন (Direct and Indirect Speech) ➔",
    "topicssymbol": "CE10",
  },



  {
    "_id": {
      "$oid": "gkmocktest01"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "1-নদ-নদী, মাটি, জলবায়ু, জাতীয় উদ্যান এবং প্রতিবেশী রাজ্য ও দেশ ➔",
    "topicssymbol": "CG01",
  },
{
    "_id": {
      "$oid": "gkmocktest02"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "2-বাংলার নবজাগরণ, স্বাধীনতা আন্দোলনে বাংলার ভূমিকা এবং বিখ্যাত ব্যক্তিদের জীবনী ➔",
    "topicssymbol": "CG02",
  },
{
    "_id": {
      "$oid": "gkmocktest03"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "3-পশ্চিমবঙ্গের অর্থনীতি ও প্রকল্প: কন্যাশ্রী, সবুজ সাথী, রূপশ্রী ইত্যাদি সরকারি প্রকল্প ➔",
    "topicssymbol": "CG03",
  },
{
    "_id": {
      "$oid": "gkmocktest04"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "4-প্রাচীন ভারত: সিন্ধু সভ্যতা, মৌর্য বংশ, গুপ্ত সাম্রাজ্য এবং গৌড় ও পাল বংশ ➔",
    "topicssymbol": "CG04",
  },
{
    "_id": {
      "$oid": "gkmocktest05"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "5-পর্বতশ্রেণী (হিমালয়), প্রধান নদীসমূহ, কৃষি ও খনিজ সম্পদ ➔",
    "topicssymbol": "CG05",
  },
{
    "_id": {
      "$oid": "gkmocktest06"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "6-সংবিধানের ভিত্তি: মৌলিক অধিকার ও কর্তব্য, প্রস্তাবনা এবং নির্দেশমূলক নীতি ➔",
    "topicssymbol": "CG06",
  },
{
    "_id": {
      "$oid": "gkmocktest07"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "7-শাসন ব্যবস্থা: রাষ্ট্রপতি, প্রধানমন্ত্রী, সংসদ এবং বিচার ব্যবস্থা ➔",
    "topicssymbol": "CG07",
  },
{
    "_id": {
      "$oid": "gkmocktest08"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "8-পঞ্চায়েত ব্যবস্থা: পশ্চিমবঙ্গের ত্রিস্তর পঞ্চায়েত ব্যবস্থা ➔",
    "topicssymbol": "CG08",
  },
{
    "_id": {
      "$oid": "gkmocktest09"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "9-ভৌত বিজ্ঞান: আলো, শব্দ, তাপ, বিদ্যুৎ এবং মৌলিক রাসায়নিক সংকেত ➔",
    "topicssymbol": "CG09",
  },
{
    "_id": {
      "$oid": "gkmocktest10"
    },
    "topicstype": "mocktest",
    "topicssubject": "gk",
    "topicsname": "10-পুরস্কার ও সম্মান: নোবেল পুরস্কার, ভারতরত্ন, অস্কার, সাহিত্য একাডেমি ইত্যাদি ➔",
    "topicssymbol": "CG10",
  },



]




export default SubjectTopicName;